"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CloseIcon = function (_Component) {
  _inherits(CloseIcon, _Component);

  function CloseIcon() {
    _classCallCheck(this, CloseIcon);

    return _possibleConstructorReturn(this, (CloseIcon.__proto__ || Object.getPrototypeOf(CloseIcon)).apply(this, arguments));
  }

  _createClass(CloseIcon, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        { width: "12", height: "12", viewBox: "0 0 12 12", version: "1.1" },
        _react2.default.createElement(
          "g",
          { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
          _react2.default.createElement(
            "g",
            { transform: "translate(-895.000000, -118.000000)" },
            _react2.default.createElement(
              "g",
              { transform: "translate(359.000000, 105.000000)" },
              _react2.default.createElement(
                "g",
                { transform: "translate(536.000000, 13.000000)" },
                _react2.default.createElement("path", { d: "M0 1.5L4.5 6 0 10.5 1.5 12 6 7.5 10.5 12 12 10.5 7.5 6 12 1.5 10.5 0 6 4.5 1.5 0 0 1.5Z" })
              )
            )
          )
        )
      );
    }
  }]);

  return CloseIcon;
}(_react.Component);

exports.default = CloseIcon;